import { spawn } from 'redux-saga/effects';

import { sagas as ipSagas } from './ipModule';
import { sagas as dynamicChild } from './dynamicChildModule';

export default function* limitsSagas() {
	yield spawn(ipSagas);
	yield spawn(dynamicChild);
}
